import { Outlet } from 'react-router'

import { Breadcrumb } from '@ui/components/navigation'
import { ExtraParams } from '@ui/interfaces/navigation'
import { Destination } from '@ui/pages/destinations/Destination'
import { Destinations } from '@ui/pages/destinations/Destinations'
import { NewDestination } from '@ui/pages/destinations/NewDestination'
import { RouteNamesEnum } from '@ui/router/routes'

export const DestinationRoutes = () => ({
  name: RouteNamesEnum.DESTINATIONS,
  path: 'destinations',
  element: <Outlet />,
  handle: {
    crumb: (data: ExtraParams) => (
      <Breadcrumb crumbStyle={data.crumbStyle} to={`/instances/${data.instanceId}/destinations`} label="Destinations" />
    ),
  },
  children: [
    {
      index: true,
      element: <Destinations />,
    },
    {
      path: 'new',
      element: <NewDestination />,
      handle: {
        crumb: (data: ExtraParams) => (
          <Breadcrumb
            crumbStyle={data.crumbStyle}
            to={`/instances/${data.instanceId}/destinations`}
            label="New Destination"
          />
        ),
      },
    },
    {
      path: ':destinationId',
      element: <Destination />,
      handle: {
        crumb: (data: ExtraParams) => {
          return (
            <Breadcrumb
              crumbStyle={data.crumbStyle}
              to={`/instances/${data.instanceId}/destinations/${data.destinationId}`}
              label={data.destinationId}
            />
          )
        },
      },
    },
  ],
})
